import { client } from "Service/axios";
import { cachedGet } from "Service/cachedGet";
import { ReadCacheOptions } from "Service/queryCache";
import {
  NOTIFICATIONS,
  NOTIFICATIONS_HIDE_ALL,
  NOTIFICATIONS_MARK_READ,
  NOTIFICATIONS_MARK_READ_ALL,
} from "Shared/Constants/apiRequest";
import {
  INotificationsParams,
  PaginatedNotificationsList,
} from "Shared/Types/notifications";

class Notifications {
  getNotificationsList(
    params: INotificationsParams | null,
    options: ReadCacheOptions = {},
  ) {
    return cachedGet<PaginatedNotificationsList>(NOTIFICATIONS, params, {
      ttlMs: 30000,
      tags: ["notifications"],
      ...options,
    });
  }
  hideAllNotifications() {
    return client.post(NOTIFICATIONS_HIDE_ALL);
  }
  markAsRead(id: string) {
    return client.post(NOTIFICATIONS_MARK_READ(id));
  }
  markAllReadNotifications() {
    return client.post(NOTIFICATIONS_MARK_READ_ALL);
  }
}

export default Notifications;
